import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "radio-label" }
const _hoisted_2 = ["checked", "disabled", "name", "value"]


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioButton',
  props: {
  optionId: {
    type: Number,
    default: 0
  },
  checked: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  packMembers: {
    type: Array,
    default: () => []
  },
  label: {
    type: String,
    default: 'label'
  },
  className: {
    type: String,
    default: 'radio'
  },
  values: {
    type: String
  },
  name: {
    type: String
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["radio-lbl", { disabled: __props.disabled }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClick', $event)))
    }, [
      _createTextVNode(_toDisplayString(__props.label) + " ", 1),
      _createElementVNode("input", {
        type: "radio",
        checked: __props.checked,
        disabled: __props.disabled,
        name: __props.name,
        value: __props.values,
        class: _normalizeClass(__props.className),
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onChange', $event)))
      }, null, 42, _hoisted_2),
      _createElementVNode("span", {
        class: _normalizeClass(["checkmark", { disabled: __props.disabled }])
      }, null, 2)
    ], 2)
  ]))
}
}

})